/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:43:39
 */
const s = {
    ballDistance: 17.9,
    diameter: 6.27,
    numRows: 15,
    yMult: 1.12,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [203.704678589937, 201.41666980723733, 224.13659128513444, 227.27186816855186, 202.5741448475845, 203.42843562479933, 224.46206697581945, 225.89762093768198],
        1: [201.5591406321927, 201.02384760507405, 201.34435460095432, 226.55610895049884, 227.4427880135298, 200.2223607346718, 225.66348313135282, 203.2583072844607],
        2: [201.37534589619293, 225.65693835237943, 226.82710558149455, 200.77923167578365, 225.36529020811307, 203.4684141149046, 226.34437472860824, 226.74191712911218],
        3: [224.51131927370827, 202.08763529909066, 202.57980750061822, 226.12437847326876, 202.80437757795517, 226.97463853865477, 201.87954995090837, 227.27220648339284],
        4: [227.21868772429292, 226.72752745538378, 201.0993192508164, 227.73182187024727, 201.537006410456, 226.7266404756563, 225.45256331976287, 226.9796328562881],
        5: [224.38771334784698, 224.64910279654984, 200.60488876427553, 225.13896136074663, 225.0639589874798, 202.05605887959757, 225.49414401262996, 200.4785853379473],
        6: [225.67550065082867, 227.07358004699583, 225.36924225900452, 227.0988272272477, 203.681366529554, 224.45988336414536, 224.35017366609563, 201.28413340208647],
        7: [226.37076330923284, 227.8503304879447, 225.069572607347, 202.65040229501705, 224.13042587193698, 225.64109996607505, 225.25211999637185, 225.99226004773706],
        8: [200.74158775462757, 226.49516135182014, 225.96024710711754, 202.29312442621728, 202.10129549826735, 203.03377278872858, 224.13842095612657, 200.38710746213988],
        9: [202.64746778866845, 201.0115096776398, 202.27714468944723, 200.90510614349958, 224.72157274348424, 203.87610448578613, 226.97192986872247, 225.0686103514115],
        10: [226.8221950392287, 203.7144687560075, 200.81015124205487, 225.55297803692147, 224.37071671770175, 201.06124064451188, 226.4195199393478, 203.68518221115815],
        11: [227.87384359286332, 227.2110778146151, 202.71767537092575, 226.6702538350305, 202.64691307057478, 225.08961540203074, 226.71555592786845, 226.666073335921],
        12: [227.1646839900465, 227.7952109561375, 225.4214137116235, 201.2510716915398, 200.8101192511233, 225.44233797079406, 226.63933298996744, 202.02910062155277],
        13: [227.85878218103343, 200.60416727187723, 225.10056039655313, 226.88999533564768, 225.29440592282864, 200.74427509290072, 202.08878780156118, 200.57985098627478],
        14: [226.90583586718512, 227.11774864374087, 201.9596383250383, 203.91225726482577, 224.72422402681212, 203.27244821378966, 226.92318345503557, 226.7307959298663],
        15: [226.6665878773202, 200.7307852601128, 202.08416721649726, 226.46099474976617, 203.9001746691803, 225.34477779265816, 225.35477833872207, 226.65348458623907],
        16: []
    }
};
export {s as default};
